import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class IrvExportPdfAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetIlanReklamRapor";
        super(baseUrl);
    }

    geExportPdfListe(sqId: string) {

        //var request = new ExportPdfListeRequest(sqId);
        let enRequest: IEnIrvRequest = {
            sqId: sqId,
        };
        return this.post("", enRequest, true);
    }
}
export default new IrvExportPdfAPI();
class ExportPdfListeRequest {
    public sqId: string;

    constructor(sicilKodu: string) {

        this.sqId = sicilKodu;

    }
}
interface IEnIrvRequest {
    sqId: string
}
export { ExportPdfListeRequest };